import { Modal, ModalHeader, ModalBody, Button, Input, Label, FormGroup } from 'reactstrap';
import { useState } from 'react';

interface AssignTicketModalProps {
  onSubmit: (userId: string) => void;
  onClose: () => void;
  title: string;
  currentUserId?: string | null;
}

const AssignTicketModal = ({ onSubmit, onClose, title, currentUserId }: AssignTicketModalProps) => {
  const [userId, setUserId] = useState('');

  const handleSubmit = () => {
    if (!userId.trim()) {
      return;
    }
    onSubmit(userId.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && userId.trim()) {
      handleSubmit();
    }
  };

  return (
    <Modal isOpen toggle={onClose} className="modal-md" centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody className="d-flex flex-column gap-4">
        {currentUserId && (
          <div className="alert alert-info mb-0" role="alert">
            <strong>Currently assigned to:</strong> {currentUserId}
          </div>
        )}

        <FormGroup className="mb-0">
          <Label for="userId">User ID</Label>
          <Input
            id="userId"
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter user ID"
            autoFocus
          />
        </FormGroup>

        <Button disabled={!userId.trim()} color="primary" onClick={handleSubmit}>
          {currentUserId ? 'Reassign Ticket' : 'Assign Ticket'}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default AssignTicketModal;
